import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=6353c61b&scoped=true&"
import script from "./Entities.vue?vue&type=script&lang=js&"
export * from "./Entities.vue?vue&type=script&lang=js&"
import style0 from "./Entities.vue?vue&type=style&index=0&id=6353c61b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6353c61b",
  null
  
)

export default component.exports